import { render, staticRenderFns } from "./PatientCreateReview.vue?vue&type=template&id=72664f19"
import script from "./PatientCreateReview.vue?vue&type=script&lang=js"
export * from "./PatientCreateReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports